import React, { memo } from 'react';
import { MarkdownTextPrimitive } from "@assistant-ui/react-markdown";
import { useContentPartText } from "@assistant-ui/react";
import remarkGfm from "remark-gfm";

const MarkdownTextImpl = () => {
  const { text } = useContentPartText();
  
  // Handle all types of newline sequences consistently
  let processedText = text;
  
  // Convert literal \n strings to actual newlines
  processedText = processedText.replace(/\\n/g, '\n');
  
  // Then normalize all newlines to ensure proper markdown parsing
  processedText = processedText.replace(/\r\n/g, '\n'); // Windows line endings
  processedText = processedText.replace(/\r/g, '\n');   // Mac line endings
  
  return (
    <MarkdownTextPrimitive
      text={processedText}
      remarkPlugins={[remarkGfm]}
      className="aui-md"
    />
  );
};

export const MarkdownText = memo(MarkdownTextImpl);